import loadRoundtable from './services/roundtable/loadRoundtable';
import deleteRoundtable from './services/roundtable/deleteRoundtable';
import myRoundtableIdentity from './services/roundtable/myRoundtableIdentity';
import autoJoinRoundtable from './services/roundtable/autoJoinRoundtable';
import removeStudent from './services/roundtable/removeStudent';
import removeStudents from './services/roundtable/removeStudents';
import publishRoundtable from './services/roundtable/publishRoundtable';
import updateRoundtable from './services/roundtable/updateRoundtable';
import changeRTImage from './services/roundtable/changeRTImage';
import submitResponse from './services/roundtable/submitResponse';
import byPassSubmission from './services/roundtable/byPassSubmission';
import createRT from './services/roundtable/createRT';
import duplicateRT from './services/roundtable/duplicateRT';
import createPremade from './services/roundtable/createPremade';
import sendEmailReminder from './services/roundtable/sendEmailReminder';
//
import addSubmissionPoint from './services/submission/addSubmissionPoint';
import removeSubmissionPoint from './services/submission/removeSubmissionPoint';
import saveAssessment from './services/submission/saveAssessment';
import saveDraftAssessment from './services/submission/saveDraftAssessment';

import toggleModelResponse from './services/submission/toggleModelResponse';
import toggleHideSubmission from './services/submission/toggleHideSubmission';
import toggleHideComment from './services/roundtable/toggleHideComment';
import flagSubmission from './services/submission/flagSubmission';
import unflagSubmission from './services/submission/unflagSubmission';
import viewSubmission from './services/submission/viewSubmission';
import getSubmissionHistory from './services/submission/getSubmissionHistory';
import loadSubmissionComments from './services/submission/loadSubmissionComments';
import gradeSubmission from './services/submission/gradeSubmission';
import pinSubmission from './services/submission/pinSubmission';
import createTeacherSubmission from './services/roundtable/createTeacherSubmission';
import deleteSubmission from './services/submission/deleteSubmission';
import editSubmission from './services/submission/editSubmission';
import markSubmissionAsRead from './services/submission/markSubmissionAsRead';
import updateKeywords from './services/roundtable/updateKeywords';
import keywordGenerationForOlderRoundtables from './services/roundtable/keywordGenerationForOlderRoundtables';
import plagiarismScoreGenerationForOlderRoundtables from './services/roundtable/plagiarismScoreGenerationForOlderRoundtables';
import getRoundtableKeywords from './services/roundtable/getRoundtableKeywords';
import getRoundtablePlagiarismScores from './services/roundtable/getRoundtablePlagiarismScores';
//
import postComment from './services/comment/postComment';
import flagComment from './services/comment/flagComment';
import unflagComment from './services/comment/unflagComment';
import pinComment from './services/comment/pinComment';
import deleteComment from './services/comment/deleteComment';
import toggleStar from './services/comment/toggleStar';
import editModelSubmission from './services/comment/editModelSubmission';
import postRecapComment from './services/comment/postRecapComment';
import getRecapComments from './services/comment/getRecapComments';

import studentSummary from './services/grades/studentSummary';
import submitDraftEvaluation from './services/grades/submitDraftEvaluation';
import submitEvaluation from './services/grades/submitEvaluation';
import selectAutomatedFeedback from './services/grades/selectAutomatedFeedback';
import refreshAutomatedFeedback from './services/grades/refreshAutomatedFeedback';
import selectSavedFeedback from './services/grades/selectSavedFeedback';

import generateExportableData from './services/generateExportableData';
import getSummaryTableData from './services/getSummaryTableData';
import addToUniverse from './services/roundtable/addToUniverse';
import syncRTAssessmentData from './services/roundtable/syncRTAssessmentData';
import syncCourseWork from './services/roundtable/syncCourseWork';
import gradeClassroomStudents from './services/roundtable/gradeClassroomStudents';
import gradeClassroomStudentsJobStatus from './services/roundtable/gradeGoogleClassroomStudentsJobStatus';
import getRoundtables from './services/roundtable/getRoundtables';
import getRecentRoundTablesInstructor from './services/roundtable/getRecentRoundTablesInstructor';
import getRecentRoundTablesParticipant from './services/roundtable/getRecentRoundTablesParticipant';
import sendEvaluations from './services/roundtable/sendEvaluations';

import openSubmission from './services/submission/openSubmission';

import createGenieRecap from './services/recap/createGenieRecap';
import updateGenieRecap from './services/recap/updateGenieRecap';
import deleteGenieRecap from './services/recap/deleteGenieRecap';
import getRecapByRoundtableId from './services/recap/getRecapByRoundtableId';
import genieRecapSummarizeSubmissions from './services/recap/genieRecapSummarizeSubmissions';
import genieRecapGenerateFollowUpQuestions from './services/recap/genieRecapGenerateFollowUpQuestions';
export default {
  createRT,
  duplicateRT,
  createPremade,
  updateRoundtable,
  loadRoundtable,
  deleteRoundtable,
  myRoundtableIdentity,
  autoJoinRoundtable,
  removeStudent,
  removeStudents,
  publishRoundtable,
  viewSubmission,
  getSubmissionHistory,
  addSubmissionPoint,
  removeSubmissionPoint,
  saveAssessment,
  saveDraftAssessment,
  flagSubmission,
  unflagSubmission,
  getSummaryTableData,
  pinSubmission,
  gradeSubmission,
  postComment,
  postRecapComment,
  getRecapComments,
  flagComment,
  unflagComment,
  pinComment,
  createTeacherSubmission,
  deleteSubmission,
  deleteComment,
  studentSummary,
  toggleStar,
  editModelSubmission,
  submitDraftEvaluation,
  submitEvaluation,
  changeRTImage,
  editSubmission,
  markSubmissionAsRead,
  submitResponse,
  byPassSubmission,
  sendEmailReminder,
  toggleModelResponse,
  selectAutomatedFeedback,
  refreshAutomatedFeedback,
  selectSavedFeedback,
  generateExportableData,
  updateKeywords,
  keywordGenerationForOlderRoundtables,
  plagiarismScoreGenerationForOlderRoundtables,
  addToUniverse,
  toggleHideSubmission,
  toggleHideComment,
  syncRTAssessmentData,
  syncCourseWork,
  getRoundtableKeywords,
  getRoundtablePlagiarismScores,
  loadSubmissionComments,
  gradeClassroomStudents,
  gradeClassroomStudentsJobStatus,
  getRoundtables,
  openSubmission,
  sendEvaluations,
  createGenieRecap,
  updateGenieRecap,
  deleteGenieRecap,
  getRecapByRoundtableId,
  genieRecapSummarizeSubmissions,
  genieRecapGenerateFollowUpQuestions,
  getRecentRoundTablesInstructor,
  getRecentRoundTablesParticipant
};



// WEBPACK FOOTER //
// ./src/app/features/onlineRoundtables/onlineRoundtables.services.js